import * as uiTypes from "../types/uiTypes";

const initialState = {
  snackbar: {
    open: false,
    severity: "success",
    message: "",
    transactionHash: "",
  },
  showSnackbar: { open: false, message: "" },
  loading: false,
  projectData: {},
  kolData: {},
  campaignData: {},
  allCampaignData: [],
  isUser: {},
  tableData: [],
  investmentData: [],
  claimableData: [], //kahin use nhy horaha ye
  graphQLData: [],
  kolCampaignData: {},
};

const uiReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("addProject uireducer payload", payload);
  switch (type) {
    case uiTypes.TOGGLE_THEME:
      const theme = state.theme === "dark" ? "light" : "dark";
      localStorage.setItem("theme", theme);
      return { ...state, theme };
    case uiTypes.LOADING:
      return { ...state, loading: { ...state.loading, ...payload } };
    // case uiTypes.SHOW_SNACKBAR:
    //   return {
    //     ...state,
    //     snackbar: { open: true, transactionHash: "", ...payload },
    //   };
    case uiTypes.SHOW_SNACKBAR: {
      return {
        ...state,
        showSnackbar: action.payload,
      };
    }
    case uiTypes.HIDE_SNACKBAR:
      return { ...state, snackbar: { open: false, transactionHash: "" } };
    case uiTypes.SHOW_SNACKBAR_INDEEP:
      return { ...state, snackbar: { open: true, ...payload } };
    case uiTypes.INITIALLY_RENDERED:
      return { ...state, initialRender: false };
    case uiTypes.SHOW_MODAL:
      return { ...state, modal: payload };

    case uiTypes.SET_LOADING:
      return { ...state, loading: payload };

    case uiTypes.SET_PROJECT_DATA:
      return { ...state, projectData: { ...state.projectData, ...payload } };
    case uiTypes.SET_KOL_DATA:
      return { ...state, kolData: { ...state.kolData, ...payload } };
    case uiTypes.SET_CAMPAIGN_DATA:
      return { ...state, campaignData: { ...state.campaignData, ...payload } };
    case uiTypes.SET_ALL_CAMPAIGN_DATA:
      return {
        ...state,
        allCampaignData: [...payload],
      };

    case uiTypes.SET_IS_USER:
      return {
        ...state,
        isUser: { ...payload },
      };

    case uiTypes.SET_INVESTMENT_DATA:
      return {
        ...state,
        investmentData: { ...payload },
      };
    case uiTypes.SET_TABLE_DATA:
      return { ...state, tableData: [...payload] };

    case uiTypes.SET_CLAIMABLE_DATA:
      return { ...state, claimableData: [...payload] };

    case uiTypes.SET_GRAPHQL_DATA:
      return { ...state, graphQLData: [...payload] };

    default:
      return state;
  }
};

export default uiReducer;
